module.exports = __webpack_public_path__ + "img/shalbon-bihar.257d04fa.jpg";